import classNames from 'classnames';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import MellowIllustration from '@/components/MellowIllustration';

import styles from './index.module.scss';

type Props = {
  readonly title?: ReactNode;
  readonly size?: 'large' | 'medium' | 'small';
  readonly className?: string;
};

function EmptyDataPlaceholder({ title, size = 'medium', className }: Props) {
  const { t } = useTranslation(undefined, { keyPrefix: 'admin_console' });

  return (
    <div className={classNames(styles.empty, styles[size], className)}>
      <div className={styles.topSpace} />
      <MellowIllustration scene="activity" className={styles.image} />
      <div className={styles.title}>{title ?? t('errors.empty')}</div>
      <div className={styles.bottomSpace} />
    </div>
  );
}

export default EmptyDataPlaceholder;
